// Centralised backend base-URL resolver.
//
// Why this exists:
//   The Emergent deployment platform injects REACT_APP_BACKEND_URL at build
//   time. In production it has been injecting the stage origin
//   (https://checkup-stage.emergent.host), which is CROSS-ORIGIN from the
//   canonical site https://finance-vitals.com. Browsers reject the resulting
//   POSTs with a CORS error, and Cloudflare returns 520 because the stage
//   origin doesn't accept the canonical domain as an allowed origin.
//
// Fix: at runtime in the browser, if the configured backend URL is not
// same-origin with the page, fall back to an empty prefix so all API calls
// become relative ("/api/...") and are routed by the canonical domain's
// ingress (Cloudflare → kube ingress → backend on :8001).
//
// On the preview pod the configured URL is same-origin already, so this is
// a no-op there.

const RAW_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

function resolveBackendUrl() {
  // SSR / non-browser context: trust the env value as-is.
  if (typeof window === 'undefined' || !window.location) {
    return RAW_BACKEND_URL;
  }
  if (!RAW_BACKEND_URL) {
    return '';
  }
  try {
    const configured = new URL(RAW_BACKEND_URL);
    if (configured.origin === window.location.origin) {
      return RAW_BACKEND_URL;
    }
    // Cross-origin → force same-origin via empty prefix (relative /api/...).
    return '';
  } catch (err) {
    // Malformed env value → safest fallback is same-origin.
    return '';
  }
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;
